import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import styles from '../css/bg.module.css';
import {
    makeStyles,
    Typography,
    TextField,
    Button,
    IconButton,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import { userSignedIn } from '../selectors';
import { authError, updateUserInfo } from '../actions/userActions';
import { Redirect } from 'react-router-dom';
import CloseButton from '../components/CloseButton';
import InputMask from 'react-input-mask';

const useStyles = makeStyles({
    disabled: {
        color: 'var(--white)',
        fontWeight: '700',
    },
});

const Profile = ({ history, location }) => {
    const classes = useStyles();
    const [edit, setEdit] = useState(false);

    const { phoneNumber, displayName, isAnonymous } = useSelector(
        (state) => state.user
    );
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');

    useEffect(() => {
        if (location.state) {
            // came from sign up
            setEdit(true);
        }
    }, [location]);

    useEffect(() => {
        if (phoneNumber) {
            setPhone(phoneNumber);
        }
    }, [phoneNumber]);
    useEffect(() => {
        if (displayName) {
            setName(displayName);
        }
    }, [displayName]);

    const dispatch = useDispatch();

    const handleLogOut = () => {
        auth.signOut();
        history.push('/liquors');
    };
    const handleSubmit = () => {
        dispatch(updateUserInfo(name, history, phone));
        setEdit(false);
    };
    const handleCancel = () => {
        setPhone(phoneNumber || '');
        setName(displayName || '');
        setEdit(false);
    };
    const handleLinkAccount = () => {
        history.push({
            pathname: '/register',
            state: { from: '/cart', linkAccount: true },
        });
    };
    return (
        <div className={styles.bg}>
            <CloseButton history={history} to="/cart" />
            <div className={styles.center}>
                <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                    <Typography variant="h1">User Info</Typography>
                    {!edit && !isAnonymous && (
                        <IconButton
                            style={{ marginLeft: '2rem' }}
                            onClick={() => {
                                setEdit(true);
                            }}
                        >
                            <EditIcon fontSize="large" />
                        </IconButton>
                    )}
                </div>
                <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                    {!isAnonymous && (
                        <>
                            <TextField
                                variant="standard"
                                color="primary"
                                label="name"
                                value={name}
                                onChange={(event) => {
                                    setName(event.target.value);
                                }}
                                fullWidth
                                style={{
                                    marginTop: '2rem',
                                    boxSizing: 'border-box',
                                    width: '100%',
                                }}
                                disabled={!edit}
                                InputProps={{
                                    classes: { disabled: classes.disabled },
                                }}
                            />
                            <InputMask
                                mask="999-999-9999"
                                value={phone}
                                onChange={(event) => {
                                    setPhone(event.target.value);
                                }}
                                disabled={!edit}
                                maskChar=" "
                            >
                                {() => (
                                    <TextField
                                        variant="standard"
                                        color="primary"
                                        label="phone number"
                                        fullWidth
                                        disabled={!edit}
                                        style={{
                                            marginTop: '2rem',
                                            boxSizing: 'border-box',
                                            width: '100%',
                                        }}
                                        InputProps={{
                                            classes: {
                                                disabled: classes.disabled,
                                            },
                                        }}
                                    />
                                )}
                            </InputMask>
                        </>
                    )}
                    <div
                        style={{
                            marginTop: '3rem',
                        }}
                    >
                        {edit ? (
                            <>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCancel}
                                    style={{
                                        background: 'var(--grey)',
                                        marginLeft: '1rem',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </>
                        ) : isAnonymous ? (
                            <Button
                                variant="contained"
                                onClick={handleLinkAccount}
                            >
                                Upgrade to Email/Password Account
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                style={{
                                    background:
                                        'linear-gradient(315deg, #b02e0c 0%, #eb4511 74%)',
                                    color: 'var(--white)',
                                }}
                                onClick={handleLogOut}
                            >
                                Log Out
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
